import axios from "axios";

const win: any = window;
const baseUrl = win["base_api_url"];

const config = {
    api: {
        baseURL: baseUrl,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Oauth2.0": "Y"
        },
    },
};

export const api = axios.create({ ...config.api });

api.defaults.validateStatus = function () {
    return true;
};

api.interceptors.request.use(
    async (conf: any) => {
        conf.headers.Authorization = `Bearer ${win["clientToken"]}`;
        conf.headers['cem-key'] = win["CEM_KEY"];
        return conf;
    }, (err) => {
        console.log("error in getting ", err);
    }
);

const getOTP = (data: any) => {
    return api.post(`/login/otp`, data);
};

const verifyOTP = (data: any) => {
    return api.post(`/login/validateotp`, data);
};

const getOAuth = async (data: any) => {
    const url = `${baseUrl}/oauth-server/oauth/token`;
    const basicAuthToken = win["basicAuthToken"];
    const requestData = new URLSearchParams(Object.entries(data)).toString();

    return await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'cem-key': win["CEM_KEY"],
            'Authorization': `Basic ${basicAuthToken}`
        },
        body: requestData
    })
}

const getAccountDetails = async (data: any) => {
    const url = `${baseUrl}/oauth-server/oauth/token`;
    const basicAuthToken = win["basicAuthToken"];
    const requestData = new URLSearchParams(Object.entries(data)).toString();

    return await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'cem-key': win["CEM_KEY"],
            'Authorization': `Basic ${basicAuthToken}`
        },
        body: requestData
    })
}

export { getOTP, verifyOTP, getOAuth, getAccountDetails };